/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phasetriage1Inputs */

const en_phasetriage1 = /** @type {(inputs: Phasetriage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triage`)
};

const pt_phasetriage1 = /** @type {(inputs: Phasetriage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triagem`)
};

/**
* | output |
* | --- |
* | "Triage" |
*
* @param {Phasetriage1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const phasetriage1 = /** @type {((inputs?: Phasetriage1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phasetriage1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phasetriage1(inputs)
	return pt_phasetriage1(inputs)
});
export { phasetriage1 as "phaseTriage" }